import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
import actions from '../actions';
import MacheteController from '../../controller/index';

const initialState = Immutable({
  initialized: false,
});

export default handleActions(
  {
    [actions.viewer.ready]: (state) => state.set('initialized', true),
    [actions.viewer.updateMeta]: (state, { payload: { meta } }) =>
      state.set('meta', meta),
    [actions.viewer.setControls]: (state, { payload: cfg }) => {
      const ctrl = MacheteController.instance;
      if (cfg.zoom !== null) ctrl.viewer.controls.noZoom = !cfg.zoom;
      if (cfg.pan !== null) ctrl.viewer.controls.noPan = !cfg.pan;
      if (cfg.rotate !== null) ctrl.viewer.controls.noRotate = !cfg.rotate;
      return state;
    },
  },
  initialState,
);
